import { connect } from 'react-redux';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { TextConfirmationModal } from 'components';
import { createStructuredSelector } from 'reselect';
import { selectIsOpenRenameDeviceModal, selectRenameDeviceModalMetadata } from 'selectors/Common';
import { closeRenameDeviceModal } from 'actions/Common';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(closeRenameDeviceModal()),
});

type SelectedValues = {
  show: boolean,
  acceptMetadata: { [key: string]: any },
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  show: selectIsOpenRenameDeviceModal(),
  acceptMetadata: selectRenameDeviceModalMetadata(),
});

export default connect(mapStateToProps, mapDispatchToProps)(TextConfirmationModal);
